import { AxiosResponse } from 'axios';
import { getAxiosSecureInstance } from '../../utilities/AxiosClient';

export type UserModel = {
  id: string;
  email: string;
  name: string;
  firstname: string;
  avatar: string | null;
};

export type AccountModel = {
  firstname: string;
  name: string;
  email: string;
  password: string;
  culture: string;
  invitationId: string | undefined;
};

export type InvitationModel = {
  id: string;
  email: string;
  status: string;
};

export function getUsers(organizationId: string, page: number, pageSize: number): Promise<AxiosResponse<UserModel[]>> {
  return getAxiosSecureInstance().get(`/api/organizations/${organizationId}/users?page=${page}&pageSize=${pageSize}`);
}

export function getInvitations(
  organizationId: string,
  page: number,
  pageSize: number,
): Promise<AxiosResponse<InvitationModel[]>> {
  return getAxiosSecureInstance().get(
    `/api/organizations/${organizationId}/invitations?page=${page}&pageSize=${pageSize}`,
  );
}

export function createInvitation(
  organizationId: string,
  invitation: InvitationModel,
): Promise<AxiosResponse<InvitationModel>> {
  return getAxiosSecureInstance().post(`/api/organizations/${organizationId}/invite`, invitation);
}

export function deleteUser(organizationId: string, organizationUser: InvitationModel): Promise<AxiosResponse<number>> {
  return getAxiosSecureInstance().post(`/api/organizations/${organizationId}/users/delete`, organizationUser);
}

export function createAccount(newUser: AccountModel): Promise<AxiosResponse<number>> {
  return getAxiosSecureInstance().post(`/api/login/create-account`, newUser);
}

export function activateAccount(token: string): Promise<AxiosResponse<boolean>> {
  return getAxiosSecureInstance().post(`/api/login/activate-account`, { token });
}

export function acceptInvitation(invitationId: string): Promise<AxiosResponse<number>> {
  return getAxiosSecureInstance().post(`/api/login/accept-invitation`, null, { params: { invitationId } });
}

export function isEmailExists(email: string): Promise<AxiosResponse<boolean>> {
  return getAxiosSecureInstance().get(`/api/login/email-exists`, { params: { email } });
}
